import { makeStyles } from '@fluentui/react-components';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { Therm } from '../model/Therm';
import { SiteHeader } from './SiteHeader';
import { withStyles } from "./withStyles";

export interface ThermItemProps
{
    styles: Record<string, string>;
    therm: Therm;
}

export interface ThermItemState
{
}

const useStyles = makeStyles(
    {
        
    });

export class ThermItemWithoutStyles extends React.Component<ThermItemProps, ThermItemState>
{
    render()
    {
        const therm = this.props.therm;

        return (
            <tr>
                <td>{therm.ThermID}</td>
                <td>{therm.Description}</td>
            </tr>
        );
    }
}

export const ThermItem = withStyles(useStyles, ThermItemWithoutStyles);